import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";
/**
 * Genera un código OTP desde el backend.
 * Retorna { codigo, ttl, expira }
 */
export async function getOtpCode(cuenta = null) {
  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/otp/generar`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ cuenta }),
  });

  const data = await response.json();
  if (!response.ok) {
    const errorMsg = data?.message || "No se pudo generar el código OTP";
    throw new Error(errorMsg);
  }

  return data; // ejemplo: { codigo: "123456", ttl: 30 }
}

/**
 * Verifica el código OTP con el backend
 * (solo si querés validar antes de una acción)
 */
export async function verifyOtpCode(codigo) {
  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/otp/verificar`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ codigo }),
  });

  const data = await response.json();

  if (!response.ok) {
    const errorMsg = data?.message || "Código incorrecto o expirado";
    throw new Error(errorMsg);
  }

  return data; // ejemplo: { message: "Código verificado correctamente" }
}
